import React from 'react';
import { CheckCircle2, Award, Users, History } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Section } from '../components/ui/Section';
import { ContactCTA } from '../components/sections/ContactCTA';
import { Gallery } from '../components/ui/Gallery';
import { galleryImages } from '../data/mock';

export const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="bg-primary-dark py-24 text-center text-white mt-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">O Nama</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Tradicija, kvalitet i poverenje - Stolarija Leskovac.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        <Section>
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Naša Priča</h2>
            <h3 className="text-3xl font-bold mb-6 text-gray-900">
              Više od Decenije <br />
              <span className="text-primary">Iskustva i Kvaliteta</span>
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed text-lg">
              Stolarija Leskovac je porodična firma osnovana sa ciljem da tržištu ponudi vrhunska rešenja u oblasti ALU i PVC stolarije. Od male radionice izrasli smo u lidera u regionu, zahvaljujući beskompromisnom kvalitetu i posvećenosti svakom klijentu.
            </p>
            <p className="text-gray-600 mb-12 leading-relaxed text-lg">
              Naša misija je da vaš dom učinimo toplijim, sigurnijim i lepšim. Koristimo najsavremenije tehnologije i materijale renomiranih svetskih proizvođača kako bismo osigurali dugotrajnost i energetsku efikasnost svakog ugrađenog elementa.
            </p>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl mx-auto">
              <div className="flex flex-col gap-2 items-center">
                <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-primary mb-2 shadow-sm">
                  <History size={32} />
                </div>
                <h4 className="font-bold text-gray-900 text-lg">10+ Godina</h4>
                <p className="text-sm text-gray-500">Iskustva u radu</p>
              </div>
              <div className="flex flex-col gap-2 items-center">
                <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-primary mb-2 shadow-sm">
                  <Users size={32} />
                </div>
                <h4 className="font-bold text-gray-900 text-lg">500+</h4>
                <p className="text-sm text-gray-500">Zadovoljnih klijenata</p>
              </div>
              <div className="flex flex-col gap-2 items-center">
                <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-primary mb-2 shadow-sm">
                  <Award size={32} />
                </div>
                <h4 className="font-bold text-gray-900 text-lg">Garancija</h4>
                <p className="text-sm text-gray-500">Na sve radove</p>
              </div>
              <div className="flex flex-col gap-2 items-center">
                <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-primary mb-2 shadow-sm">
                  <CheckCircle2 size={32} />
                </div>
                <h4 className="font-bold text-gray-900 text-lg">Sertifikati</h4>
                <p className="text-sm text-gray-500">Kvalitet materijala</p>
              </div>
            </div>
          </div>
        </Section>

        <ContactCTA />
      </main>

      <Footer />
    </div>
  );
};
